<template>
  <div>



  <div v-if="isParent">  

    <hr />

    <div class="row" v-if="showErrorMessage">
        <div class="columns">
          <strong><label for="confirmTerms" generated="true" class="error strong smaller mbm">Please accept these Terms of Use to continue</label></strong>
        </div>
    </div>

    <div class="row mbl">

        <div class="columns small-1">
            <input style="padding-right: 5px;" name="confirmTerms" id="confirmTerms" type="checkbox" v-model="acceptTerms" />
        </div>
        <div class="columns small-11">
            <label for="confirmTerms" class="smaller">
            <strong>I agree to these Terms of Use </strong> and provide ClassForKids with explicit consent to process any special category personal data provided by me to enable Organisers to deliver Classes.
            </label>
        </div>

    </div>


    <hr />


    <div class="text-center" v-if="!clicked">
      <form method="POST" v-if="acceptTerms">     
        <button type="submit" name="button" class="info" >ACCEPT</button>
      </form>
      <div v-else>
        <a name="button" class="button info" @click="showError">ACCEPT</a>
      </div>
    </div>
    <div v-else class="text-center">
      <button disabled type="button" name="button" class="info">ACCEPT <i class="fal fa-circle-notch fa-spin fa-1x fa-fw"></i>
        <span class="sr-only">Loading...</span>
      </button>
    </div>



  </div>

  <div v-else>
    <div class="text-center" v-if="!clicked">
      <form method="POST">
        <button type="submit" name="button" class="info" >ACCEPT</button>
      </form>
    </div>

    <div v-else class="text-center">
      <button disabled type="button" name="button" class="info">ACCEPT <i class="fal fa-circle-notch fa-spin fa-1x fa-fw"></i>
        <span class="sr-only">Loading...</span>
      </button>
    </div>    
  </div>




</div>
</template>

<script>
export default {
  name: 'AcceptContractButton',
  data() {
    return {
      clicked: false,
      acceptTerms: '',
      error: false
    };
  },
  props: {
    role: {
      required: false,
      type: String
    }
  },
  computed: {
    disableButton() {
      return this.acceptTerms == false;
    },
    isParent() {
      return this.role == 'parent';
    },
    termsAccepted() {
      return this.acceptTerms == true;
    },
    showErrorMessage() {
      return this.error && !this.acceptTerms;
    }
  },
  methods: {
    contractSigned() {
      if (this.acceptTerms) {
        this.clicked = true;  
      } else {
        return false;
      }
    },
    showError() {
      this.error = true;
    }
  },
  components: {},
  created() {}
};
</script>

<style>
</style>
